/**
 * 🔄 USER ACTIONS - MIGRAÇÃO FIREBASE → POSTGRESQL
 * Actions relacionadas ao gerenciamento de usuário
 *
 * @author GestorConsig Team
 * @version 2.0.0
 * @migrated 27/12/2024
 */

import { api } from '@/store/api'
import config from '@/config/environment'

export default {
  /**
   * 🔐 Define o usuário no estado global
   * Chamada pelo router após autenticação bem-sucedida
   */
  setUser({ commit, state }, userData) {
    try {
      // Garante compatibilidade com Firebase
      if (userData && !userData.uid) {
        userData.uid = userData.id
      }

      // Define o usuário no estado
      commit('setUser', userData)
      commit('setUserData', userData)

      if (config.MONITORING.DEBUG_MODE) {
        console.log('🔄 setUser action:', {
          uid: userData?.uid || userData?.id,
          email: userData?.email,
          profile: userData?.profile || userData?.role,
          company: userData?.companyId || userData?.company_id
        })
      }
    } catch (error) {
      console.error('❌ Erro na action setUser:', error)
      throw error
    }
  },

  /**
   * 🔓 Remove o usuário do estado global
   * Chamada durante logout
   */
  clearUser({ commit }) {
    try {
      commit('setUser', null)
      commit('setUserData', null)

      if (config.MONITORING.DEBUG_MODE) {
        console.log('🔄 clearUser action: usuário removido do estado')
      }
    } catch (error) {
      console.error('❌ Erro na action clearUser:', error)
    }
  },

  /**
   * 📊 Carrega dados completos do usuário
   * Busca informações adicionais da API
   */
  async loadUserData({ commit, state }) {
    try {
      if (!state.user || !state.user.uid) {
        throw new Error('Usuário não autenticado')
      }

      const response = await api.get(`/users/${state.user.uid}`)
      const userData = response.data

      // Garante compatibilidade
      if (userData && !userData.uid) {
        userData.uid = userData.id
      }

      commit('setUserData', userData)

      if (config.MONITORING.DEBUG_MODE) {
        console.log('🔄 loadUserData action:', userData)
      }

      return userData
    } catch (error) {
      console.error('❌ Erro ao carregar dados do usuário:', error)
      throw error
    }
  }
}
